/* eslint-disable camelcase */
import Scene from "~/scene";
import { _ } from "~/i18n";
import { icon, node } from "~/util/dom";
import { getBookingLink } from "~/util/providers/booking-link";
import { createCommercialCollaboration } from "~/ui/commercialCollaboration";

interface IItem {
	geometry: string;
	source: string;
	origin: string;
	title: string;
	id: number;
}

export function createRouteBookingLink(item: IItem) {
	const span = node("span", { className: "booking-link-container" });
	const cont = node("a", { href: "#", target: "_blank", className: "booking-link-route" });
	const coords = Scene.stringToCoords(item.geometry);
	const wgs84 = coords[0].toWGS84();

	getBookingLink({
		lon: wgs84[0],
		lat: wgs84[1],
	}).then(bookingLinkData => {
		Mapy.getComponent("logger").log("planner_booking_offer_impress", {
			poi_region_booking_offer: bookingLinkData.error === "",
		});

		if (bookingLinkData.link) {
			const title = node("span", { className: "booking-link-route__title", textContent: _("bookingLink.findAccomDest") });

			cont.href = bookingLinkData.link;
			cont.append(title, icon("booking"));
			span.append(cont, createCommercialCollaboration());
		}

		cont.addEventListener("click", event => {
			if (bookingLinkData.link) {
				Mapy.getComponent("logger").log("clickBooking", {
					source: item.source,
					id: item.id,
					name: item.title,
					typeId: 7,
					placeId: 3,
					target: "booking",
				});
			} else {
				event.preventDefault();
				event.stopPropagation();
			}
		});
	});

	return span;
}
